import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

// Layout Components
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { WhatsAppButton } from './components/layout/WhatsAppButton';
import { DemoModal } from './components/layout/DemoModal';

// Pages
import { Home } from './pages/Home';
import { Solutions } from './pages/Solutions';
import { PlataformaEAD } from './pages/PlataformaEAD';
import { ProducaoCursos } from './pages/ProducaoCursos';
import { NR01 } from './pages/NR01';
import { Cases } from './pages/Cases';
import { About } from './pages/About';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';

import './App.css';

function App() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const openDemoModal = () => setIsDemoModalOpen(true);
  const closeDemoModal = () => setIsDemoModalOpen(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar onDemoClick={openDemoModal} />
        
        <main>
          <Routes>
            <Route path="/" element={<Home onDemoClick={openDemoModal} />} />
            <Route path="/solucoes" element={<Solutions onDemoClick={openDemoModal} />} />
            <Route path="/solucoes/plataforma-ead" element={<PlataformaEAD onDemoClick={openDemoModal} />} />
            <Route path="/solucoes/producao-cursos" element={<ProducaoCursos onDemoClick={openDemoModal} />} />
            <Route path="/solucoes/nr01" element={<NR01 onDemoClick={openDemoModal} />} />
            <Route path="/cases" element={<Cases onDemoClick={openDemoModal} />} />
            <Route path="/sobre" element={<About onDemoClick={openDemoModal} />} />
            <Route path="/blog" element={<Blog onDemoClick={openDemoModal} />} />
            <Route path="/contato" element={<Contact />} />
          </Routes>
        </main>

        <Footer />
        <WhatsAppButton />
        <DemoModal isOpen={isDemoModalOpen} onClose={closeDemoModal} />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
